/* Tienda Lenovo · tienda-lenovo-v2 · JS propio, diferido y sin jQuery. */
(function () {
  'use strict';
  window.lvTheme = true;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('LvConfig').textContent); } catch (e) { cfg = { t: {} }; }
  var T = cfg.t || {};
  var root = cfg.root || '/';
  var SECTION = 'lv-cart-drawer';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function sectionHTML(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var s = d.querySelector('.shopify-section');
    return s ? s.innerHTML : d.innerHTML;
  }
  function jsonResponse(r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }
  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
  }
  function trap(e, panel) {
    if (e.key !== 'Tab') return;
    var f = focusables(panel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* 1. Carrito lateral */
  var drawer = document.getElementById('LvCartDrawer');
  var content, msg, panel, lastFocus;
  if (drawer) {
    document.body.appendChild(drawer);
    content = $('[data-lv-cart-content]', drawer);
    msg = $('[data-lv-cart-msg]', drawer);
    panel = $('.lv-cd-panel', drawer);
  }
  function setCount(n) {
    $$('[data-lv-count]').forEach(function (el) {
      var ch = el.textContent != n; el.textContent = n;
      if (ch && !reduced) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function render(html) {
    if (!content) return;
    content.innerHTML = sectionHTML(html);
    var b = $('[data-count]', content);
    if (b) setCount(b.getAttribute('data-count'));
    document.dispatchEvent(new CustomEvent('lv:cart-updated'));
  }
  function showMsg(text, ok) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'lv-cd-msg' + (ok ? ' ok' : '');
    msg.hidden = !text;
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('lv-lock');
    panel.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('lv-lock');
    setTimeout(function () { drawer.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[SECTION]); })
      .catch(function () { showMsg(T.loadError); });
  }
  function change(key, qty) {
    content.classList.add('is-busy');
    fetch(cfg.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION })
    })
      .then(jsonResponse)
      .then(function (res) {
        if (!res.ok) { showMsg(res.j.description || res.j.message || T.updateError); return refresh(); }
        showMsg('');
        if (res.j.sections && res.j.sections[SECTION]) render(res.j.sections[SECTION]); else return refresh();
      })
      .catch(function () { showMsg(T.network); })
      .then(function () { content.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    if (!drawer) return;
    if (e.target.closest('[data-lv-cart-open]')) { e.preventDefault(); showMsg(''); openDrawer(); refresh(); return; }
    if (e.target.closest('[data-lv-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var q = e.target.closest('[data-lv-qty]');
    if (q && drawer.contains(q)) {
      var li = q.closest('[data-key]');
      if (li) change(li.getAttribute('data-key'), parseInt(q.getAttribute('data-lv-qty'), 10));
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form.lv-add');
    if (!f || !drawer || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btns = $$('button[type="submit"]', f).concat(f.id ? $$('button[form="' + f.id + '"]') : []);
    var label = btns.map(function (b) { return b.innerHTML; });
    btns.forEach(function (b) { b.disabled = true; if (!b.classList.contains('lv-round')) b.textContent = T.adding; });
    var fd = new FormData(f);
    fd.append('sections', SECTION);
    fetch(cfg.cartAdd + '.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(jsonResponse)
      .then(function (res) {
        if (res.ok && cfg.cartType === 'page') { window.location.href = cfg.cartUrl; return; }
        openDrawer();
        if (!res.ok) { showMsg(res.j.description || T.addError); return refresh(); }
        showMsg(T.added, true);
        if (res.j.sections && res.j.sections[SECTION]) render(res.j.sections[SECTION]); else return refresh();
      })
      .catch(function () { f.submit(); })
      .then(function () { btns.forEach(function (b, i) { b.disabled = false; b.innerHTML = label[i]; }); });
  });


  /* Descargar PDF: descarga real con fetch + blob; si falla, abre el PDF en otra pestaña */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-lv-dl]');
    if (!a || e.metaKey || e.ctrlKey || !window.fetch || !window.URL || !URL.createObjectURL) return;
    e.preventDefault();
    var url = a.href;
    var name = 'catalogo.pdf';
    try { name = decodeURIComponent(url.split('?')[0].split('/').pop()) || name; } catch (err) {}
    a.setAttribute('aria-busy', 'true');
    fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.blob();
    }).then(function (blob) {
      var obj = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = obj; link.download = name; link.style.display = 'none';
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(function () { URL.revokeObjectURL(obj); }, 4000);
    }).catch(function () {
      window.open(url, '_blank', 'noopener');
    }).then(function () { a.removeAttribute('aria-busy'); });
  });

  /* 2. Menú de categorías */
  var menu = document.getElementById('LvMenu');
  var menuLast;
  var mqDesk = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: true };
  function menuOpen(btn) {
    if (!menu) return;
    menuLast = btn || document.activeElement;
    menu.hidden = false;
    $$('details', menu).forEach(function (d) { d.open = mqDesk.matches; });
    requestAnimationFrame(function () { menu.classList.add('is-open'); });
    $$('[data-lv-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (!mqDesk.matches) document.documentElement.classList.add('lv-lock');
    var p = $('.lv-menu-panel', menu);
    if (p) p.focus();
  }
  function menuClose(restore) {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-open');
    document.documentElement.classList.remove('lv-lock');
    $$('[data-lv-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { menu.hidden = true; }, 260);
    if (restore !== false && menuLast && menuLast.focus) menuLast.focus();
  }
  /* Enlace del menú que lleva a la misma página (por ejemplo #LvServiceForm): cierra el panel y baja suave. */
  function lvGoSamePage(a) {
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return false; }
    if (u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '') || u.search !== location.search) return false;
    var target = u.hash ? document.getElementById(decodeURIComponent(u.hash.slice(1))) : null;
    if (u.hash && !target) return false;
    menuClose(false);
    var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    setTimeout(function () {
      if (target) {
        target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', u.hash);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (err) {}
      } else {
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      }
    }, 30);
    return true;
  }
  document.addEventListener('click', function (e) {
    var ob = e.target.closest('[data-lv-menu-open]');
    if (ob) { e.preventDefault(); if (menu && !menu.hidden) menuClose(); else menuOpen(ob); return; }
    if (e.target.closest('[data-lv-menu-close]')) { menuClose(); return; }
    var ma = menu && !menu.hidden && e.target.closest('#LvMenu a[href]');
    if (ma && !e.metaKey && !e.ctrlKey && !e.shiftKey && ma.target !== '_blank' && lvGoSamePage(ma)) e.preventDefault();
  });
  /* Alto del encabezado fijo: las anclas (#…) no quedan tapadas */
  (function () {
    var hd = document.querySelector('[data-lv-header]');
    var sec = hd && hd.closest('.shopify-section, [id^="shopify-section"]');
    if (!sec) return;
    function setH() {
      var sticky = getComputedStyle(sec).position === 'sticky';
      document.documentElement.style.setProperty('--lv-sticky', (sticky ? sec.offsetHeight + 12 : 12) + 'px');
    }
    setH();
    window.addEventListener('resize', setH, { passive: true });
    if (location.hash.length > 1) {
      window.addEventListener('load', function () {
        var t = null;
        try { t = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) {}
        if (t) { setH(); t.scrollIntoView({ block: 'start' }); }
      });
    }
  })();
  document.addEventListener('keydown', function (e) {
    if (menu && !menu.hidden) {
      if (e.key === 'Escape') { menuClose(); return; }
      trap(e, $('.lv-menu-panel', menu));
      return;
    }
    if (drawer && !drawer.hidden) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      trap(e, panel);
    }
  });

  /* 3. Buscador predictivo */
  $$('[data-lv-ps-form]').forEach(function (form) {
    var input = $('input[type="search"]', form), box = $('[data-lv-ps]', form), timer, ctl, lastQ = '';
    if (!input || !box || !cfg.psUrl) return;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (q === lastQ && box.innerHTML) { open(); return; }
        lastQ = q;
        if (ctl) ctl.abort();
        ctl = window.AbortController ? new AbortController() : null;
        var url = cfg.psUrl + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag' +
          '&section_id=lv-predictive-search';
        fetch(url, { signal: ctl ? ctl.signal : undefined })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (input.value.trim() !== q) return;
            box.innerHTML = sectionHTML(html);
            if (box.textContent.trim()) open(); else close();
          })
          .catch(function () {});
      }, 250);
    });
    var skipOpen = false;
    input.addEventListener('focus', function () { if (skipOpen) { skipOpen = false; return; } if (box.innerHTML.trim() && input.value.trim().length >= 2) open(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); skipOpen = true; input.focus(); skipOpen = false; return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('[role="option"]', box);
      if (box.hidden || !items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
      items.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      items[i].focus();
    });
  });

  /* 4. Estado de la tienda (hora de Colombia) */
  var bogotaFmt = null;
  function bogotaNow() {
    var parts = {};
    try {
      bogotaFmt = bogotaFmt || new Intl.DateTimeFormat('en-US', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
      bogotaFmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date(Date.now() - 5 * 3600 * 1000);
      parts = { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate(), hour: d.getUTCHours(), minute: d.getUTCMinutes() };
    }
    var h = parseInt(parts.hour, 10) % 24;
    return { y: +parts.year, m: +parts.month, d: +parts.day, min: h * 60 + parseInt(parts.minute, 10) };
  }
  function dayInfo(now, offset) {
    var dt = new Date(Date.UTC(now.y, now.m - 1, now.d + offset));
    var jsDay = dt.getUTCDay();
    var iso = dt.toISOString().slice(0, 10);
    var key = jsDay === 0 ? 7 : jsDay;
    var raw = ((cfg.hours || {})[key] || '').replace(/\s/g, '');
    var closed = (cfg.closed || '').indexOf(iso) !== -1;
    var m = raw.match(/^(\d{1,2}):?(\d{2})?-(\d{1,2}):?(\d{2})?$/);
    if (!m || closed) return { jsDay: jsDay, key: key, open: null };
    return { jsDay: jsDay, key: key, open: +m[1] * 60 + (+m[2] || 0), close: +m[3] * 60 + (+m[4] || 0) };
  }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60), mi = mins % 60, suf = h >= 12 ? 'p. m.' : 'a. m.';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + (mi ? ':' + (mi < 10 ? '0' : '') + mi : '') + ' ' + suf;
  }
  function storeStatus() {
    var now = bogotaNow(), today = dayInfo(now, 0), text = '', isOpen = false;
    if (today.open !== null && now.min >= today.open && now.min < today.close) {
      isOpen = true;
      text = (cfg.openText || '').replace('[hora]', fmtTime(today.close));
    } else {
      var when = '', at = null;
      if (today.open !== null && now.min < today.open) { when = T.today; at = today.open; }
      else {
        var days = (T.days || '').split(',');
        for (var i = 1; i <= 7; i++) {
          var di = dayInfo(now, i);
          if (di.open !== null) { when = i === 1 ? T.tomorrow : (days[di.jsDay] || ''); at = di.open; break; }
        }
      }
      if (at !== null) text = (cfg.closedText || '').replace('[dia]', when).replace('[hora]', fmtTime(at));
    }
    return { open: isOpen, text: text, todayKey: today.key };
  }
  function initStatus() {
    if (!cfg.hours) return;
    var st = storeStatus();
    if (!st.text) return;
    $$('[data-lv-store-status]').forEach(function (el) {
      el.classList.toggle('is-open', st.open);
      el.classList.toggle('is-closed', !st.open);
      var t = $('[data-lv-status-text]', el);
      if (t) t.textContent = st.text;
    });
    $$('[data-lv-status-inline]').forEach(function (el) { el.textContent = st.text; });
    $$('[data-lv-day]').forEach(function (tr) { tr.classList.toggle('is-today', +tr.getAttribute('data-lv-day') === st.todayKey); });
  }
  window.lvStoreStatus = storeStatus;

  /* 5. Banner deslizante */
  function initSliders(scope) {
    $$('[data-lv-slider]', scope).forEach(function (sl) {
      if (sl.dataset.lvReady) return;
      sl.dataset.lvReady = '1';
      var track = $('[data-lv-track]', sl);
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children), n = slides.length;
      var dots = $$('[data-lv-dot]', sl), play = $('[data-lv-play]', sl);
      var cur = 0, iv = null, userPaused = false, hover = false;
      function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function mark(i) {
        cur = i;
        dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        slides.forEach(function (s, j) { if (j === i) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      }
      function go(i) {
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        mark(i);
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { var i = idx(); if (i !== cur) mark(i); });
      }, { passive: true });
      var prev = $('[data-lv-prev]', sl), next = $('[data-lv-next]', sl);
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      function tick() { if (!userPaused && !hover && !document.hidden) go(cur + 1); }
      var still = reduced;
      function start() { if (iv || n < 2 || sl.dataset.autoplay !== 'true' || still) return; iv = setInterval(tick, (+sl.dataset.speed || 6) * 1000); }
      function setPaused(p) {
        userPaused = p;
        if (!play) return;
        play.setAttribute('aria-pressed', p ? 'true' : 'false');
        var lb = $('[data-lv-play-label]', play);
        if (lb) lb.textContent = p ? lb.getAttribute('data-play') : lb.getAttribute('data-pause');
      }
      if (play) {
        if (still) setPaused(true);
        play.addEventListener('click', function () {
          setPaused(!userPaused);
          if (!userPaused) { still = false; start(); }
        });
      }
      sl.addEventListener('mouseenter', function () { hover = true; });
      sl.addEventListener('mouseleave', function () { hover = false; });
      sl.addEventListener('focusin', function () { hover = true; });
      sl.addEventListener('focusout', function () { hover = false; });
      track.addEventListener('touchstart', function () { setPaused(true); }, { passive: true });
      window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; });
      mark(0);
      start();
    });
  }

  /* 6. Contador de ofertas (hora de Colombia, UTC-5) */
  var CO = 5 * 3600 * 1000;
  function endFor(el) {
    if (el.dataset.mode === 'weekly') {
      var n = new Date(Date.now() - CO), add = (7 - n.getUTCDay()) % 7;
      return Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate() + add, 23, 59, 59) + CO;
    }
    var m = (el.dataset.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return 0;
    var hasTime = m[4] !== undefined;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59) + CO;
  }
  function initCountdowns(scope) {
    $$('[data-lv-countdown]', scope).forEach(function (el) {
      if (el.dataset.lvReady) return;
      el.dataset.lvReady = '1';
      var end = endFor(el);
      if (!end) return;
      var d = $('[data-d]', el), h = $('[data-h]', el), mi = $('[data-m]', el), s = $('[data-s]', el), iv;
      function pad(x) { return (x < 10 ? '0' : '') + x; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          if (el.dataset.mode === 'weekly') { end = endFor(el); return; }
          el.hidden = true; clearInterval(iv); return;
        }
        el.hidden = false;
        d.textContent = Math.floor(left / 86400);
        h.textContent = pad(Math.floor(left % 86400 / 3600));
        mi.textContent = pad(Math.floor(left % 3600 / 60));
        s.textContent = pad(left % 60);
      }
      iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* 7. Ficha de producto */
  function initPdp(scope) {
    $$('[data-lv-pdp]', scope).forEach(function (pdp) {
      if (pdp.dataset.lvReady) return;
      pdp.dataset.lvReady = '1';
      saveRecent(pdp.getAttribute('data-handle'));

      var stage = $('[data-lv-stage]', pdp), slides = $$('[data-lv-mslide]', pdp), thumbs = $$('[data-lv-thumb]', pdp), cur = 0;
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, j) { sl.classList.toggle('is-on', j === cur); });
        thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
        if (stage) stage.classList.remove('is-zoom');
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      if (stage) {
        var x0 = null;
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
          x0 = null;
        });
        if (window.matchMedia && matchMedia('(hover: hover) and (min-width: 990px)').matches) {
          stage.addEventListener('mousemove', function (e) {
            var img = $('.lv-mslide.is-on img', stage);
            if (!img) return;
            var r = stage.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
            stage.classList.add('is-zoom');
          });
          stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
        }
      }

      var qi = $('[data-lv-qty-input]', pdp);
      $$('[data-lv-q]', pdp).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qi) return;
          qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-lv-q'), 10));
        });
      });

      var tabs = $$('[role="tab"]', pdp);
      function sel(t) {
        tabs.forEach(function (x) {
          var on = x === t, pn = document.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
          if (pn) pn.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!k) return;
          var n = tabs[(i + k + tabs.length) % tabs.length]; sel(n); n.focus();
        });
      });

      var vj = $('[data-lv-variants]', pdp), opts = $('[data-lv-opts]', pdp);
      if (vj && opts) {
        var vars = [];
        try { vars = JSON.parse(vj.textContent); } catch (err) {}
        var groups = $$('[data-lv-opt]', opts);
        function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
        function update() {
          var s = selected(), vr = null;
          vars.forEach(function (x) { if (x.options.every(function (o, i) { return o === s[i]; })) vr = x; });
          groups.forEach(function (g, gi) {
            var lab = $('[data-lv-opt-sel]', g), chk = $('input:checked', g);
            if (lab && chk) lab.textContent = chk.value;
            $$('input', g).forEach(function (inp) {
              var ok = vars.some(function (x) { return x.available && x.options[gi] === inp.value && x.options.every(function (o, i) { return i === gi || o === s[i]; }); });
              var l = inp.nextElementSibling;
              if (l && !inp.disabled) l.classList.toggle('is-na', !ok);
            });
          });
          var btns = $$('.lv-padd', pdp), vid = $('[data-lv-vid]', pdp);
          if (!vr) { btns.forEach(function (b) { b.disabled = true; b.textContent = T.unavailable; }); return; }
          if (vid) vid.value = vr.id;
          var pr = $('[data-lv-price]', pdp);
          if (pr) pr.innerHTML = vr.compare
            ? '<s class="lv-was"><span class="lv-vh">' + esc(T.regular) + ': </span>' + vr.compare + '</s><span class="lv-now"><span class="lv-vh">' + esc(T.salePrice) + ': </span>' + vr.price + '</span><span class="lv-save">' + T.save + ' ' + vr.save + ' (-' + vr.pct + '%)</span>'
            : '<span class="lv-now">' + vr.price + '</span>';
          var badge = $('[data-lv-badge]', pdp);
          if (badge) { badge.hidden = !vr.compare; badge.textContent = '-' + vr.pct + '%'; }
          var sp = $('[data-lv-sticky-price]', pdp); if (sp) sp.textContent = vr.price;
          var st = $('[data-lv-stock]', pdp);
          if (st) st.innerHTML = !vr.available ? '<span class="lv-stock is-out">' + T.soldOut + '</span>'
            : (vr.low ? '<span class="lv-stock is-low">' + (T.lowStock || '').replace('[n]', vr.low) + '</span>' : '<span class="lv-stock">' + T.available + '</span>');
          var sku = $('[data-lv-sku]', pdp), skv = $('[data-lv-sku-v]', pdp);
          if (sku && skv) { skv.textContent = vr.sku || ''; sku.hidden = !vr.sku; }
          btns.forEach(function (b) { b.disabled = !vr.available; b.textContent = vr.available ? T.addToCart : T.soldOut; });
          if (typeof vr.m === 'number' && vr.m >= 0 && vr.m < slides.length) show(vr.m);
          if (window.history && history.replaceState) {
            var u = new URL(window.location.href); u.searchParams.set('variant', vr.id); history.replaceState({}, '', u.toString());
          }
        }
        opts.addEventListener('change', update);
        update();
      }

      var sticky = $('[data-lv-psticky]', pdp), ab = $('[data-lv-addbtn]', pdp);
      if (sticky && ab) {
        var chk = function () {
          var on = ab.getBoundingClientRect().bottom < 0 && window.innerWidth < 990;
          sticky.classList.toggle('is-on', on);
          document.documentElement.classList.toggle('lv-has-sticky', on);
        };
        window.addEventListener('scroll', chk, { passive: true });
        chk();
      }
    });
  }

  /* 8. Vistos recientemente */
  var RKEY = 'lv-recent';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(handle) {
    if (!handle) return;
    try {
      var l = readRecent().filter(function (h) { return h !== handle; });
      l.unshift(handle);
      localStorage.setItem(RKEY, JSON.stringify(l.slice(0, 12)));
    } catch (e) {}
  }
  function money(c) { return '$' + Math.round((+c || 0) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function initRecent(scope) {
    $$('[data-lv-recent]', scope).forEach(function (sec) {
      if (sec.dataset.lvReady) return;
      sec.dataset.lvReady = '1';
      var pdp = $('[data-lv-pdp]');
      var current = pdp ? pdp.getAttribute('data-handle') : null;
      var list = readRecent().filter(function (h) { return h !== current; }).slice(0, +sec.dataset.limit || 4);
      if (!list.length) return;
      var ul = $('[data-lv-recent-list]', sec), bpTag = sec.dataset.bpTag;
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        var html = ps.filter(Boolean).map(function (p) {
          var bp = !p.price || (bpTag && (p.tags || []).indexOf(bpTag) !== -1);
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=300' : p.featured_image + '?width=300') : '';
          var price = bp ? esc(sec.dataset.bpText) : (p.price_varies ? esc(sec.dataset.from) + ' ' : '') + money(p.price);
          return '<li><a class="lv-recent-i" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="120" height="120" loading="lazy">' : '<span class="lv-ps-noimg"></span>') +
            '<span class="lv-recent-t">' + esc(p.title) + '</span><b>' + price + '</b></a></li>';
        }).join('');
        if (html) { ul.innerHTML = html; sec.hidden = false; }
      });
    });
  }

  /* 9. Productos relacionados */
  function initReco(scope) {
    $$('[data-lv-reco]', scope).forEach(function (el) {
      if (el.dataset.lvReady || !el.dataset.url) return;
      el.dataset.lvReady = '1';
      if ($('.lv-grid', el)) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var n = d.querySelector('[data-lv-reco]');
          if (n && $('.lv-grid', n)) el.innerHTML = n.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* 10. Colecciones y búsqueda: filtros, orden y "Cargar más" */
  function initColl(scope) {
    $$('[data-lv-coll]', scope).forEach(function (rootEl) {
      if (rootEl.dataset.lvReady) return;
      rootEl.dataset.lvReady = '1';
      var sid = rootEl.getAttribute('data-section');
      var mqMobile = window.matchMedia ? matchMedia('(max-width: 989px)') : { matches: false };
      function swap(html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var n = d.querySelector('[data-lv-coll]');
        if (!n) return false;
        rootEl.innerHTML = n.innerHTML;
        rootEl.classList.remove('is-side');
        delete rootEl.dataset.lvReady;
        document.documentElement.classList.remove('lv-lock');
        init(rootEl.parentNode || document);
        return true;
      }
      function load(url, push) {
        rootEl.classList.add('is-loading');
        var u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', sid);
        fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            u.searchParams.delete('section_id');
            if (swap(html) && push && window.history) { history.pushState({ lv: 1 }, '', u.pathname + u.search); window.lvPushed = true; }
            var top = rootEl.getBoundingClientRect().top + window.pageYOffset - 150;
            if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
          })
          .catch(function () { window.location.href = url; })
          .then(function () { rootEl.classList.remove('is-loading'); });
      }
      function formUrl(form) {
        var fd = new FormData(form), p = new URLSearchParams();
        fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
        var s = $('[data-lv-sort]', rootEl);
        if (s && !p.has('sort_by')) p.set('sort_by', s.value);
        return form.getAttribute('action') + '?' + p.toString();
      }
      var form = $('[data-lv-facets]', rootEl), timer;
      if (form) {
        form.addEventListener('change', function (e) {
          if (mqMobile.matches) return;
          if (e.target.hasAttribute('data-lv-price-in')) return;
          clearTimeout(timer);
          timer = setTimeout(function () { load(formUrl(form), true); }, 150);
        });
        $$('[data-lv-price-in]', form).forEach(function (inp) {
          inp.addEventListener('change', function () { if (!mqMobile.matches) load(formUrl(form), true); });
        });
        form.addEventListener('submit', function (e) { e.preventDefault(); load(formUrl(form), true); });
      }
      var sort = $('[data-lv-sort]', rootEl);
      if (sort) sort.addEventListener('change', function () {
        if (form) { load(formUrl(form), true); return; }
        var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); load(u.toString(), true);
      });
      if (rootEl._lvBound) return;
      rootEl._lvBound = true;
      rootEl.addEventListener('click', function (e) {
        var fm = e.target.closest('[data-lv-fg-more]');
        if (fm) {
          var ul = fm.previousElementSibling;
          var open = ul && ul.classList.toggle('is-open');
          fm.textContent = open ? T.showLess : fm.getAttribute('data-label');
          return;
        }
        var a = e.target.closest('.lv-chip, .lv-clear, .lv-qchip');
        if (a && a.href && rootEl.contains(a)) { e.preventDefault(); load(a.href, true); return; }
        if (e.target.closest('[data-lv-side-open]')) { rootEl.classList.add('is-side'); document.documentElement.classList.add('lv-lock'); var sd = $('[data-lv-side]', rootEl); if (sd) { var fb = focusables(sd)[0]; if (fb) fb.focus(); } return; }
        if (e.target.closest('[data-lv-side-close]')) { rootEl.classList.remove('is-side'); document.documentElement.classList.remove('lv-lock'); return; }
        var more = e.target.closest('[data-lv-more]');
        if (more) {
          e.preventDefault();
          if (more.getAttribute('aria-busy') === 'true') return;
          more.textContent = T.loading;
          more.setAttribute('aria-busy', 'true');
          var u = new URL(more.href, window.location.origin);
          u.searchParams.set('section_id', sid);
          fetch(u.toString(), { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var d = document.createElement('div');
              d.innerHTML = html;
              var grid = $('[data-lv-grid]', rootEl), ng = d.querySelector('[data-lv-grid]'), wrap = $('[data-lv-more-wrap]', rootEl), nw = d.querySelector('[data-lv-more-wrap]');
              var firstNew = ng ? ng.firstElementChild : null;
              if (grid && ng) while (ng.firstElementChild) grid.appendChild(ng.firstElementChild);
              if (wrap && nw) wrap.innerHTML = nw.innerHTML;
              if (firstNew) { var l = $('a[href]:not([tabindex="-1"])', firstNew); if (l) l.focus({ preventScroll: true }); }
            })
            .catch(function () { window.location.href = more.href; });
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && rootEl.classList.contains('is-side')) { rootEl.classList.remove('is-side'); document.documentElement.classList.remove('lv-lock'); }
      });
    });
  }
  window.addEventListener('popstate', function () {
    if (window.lvPushed && document.querySelector('[data-lv-coll]')) window.location.reload();
  });

  /* 11. Página del carrito */
  function initCartPage(scope) {
    $$('[data-lv-cartpage]', scope).forEach(function (cp) {
      if (cp._lvBound) return;
      cp._lvBound = true;
      var sid = cp.getAttribute('data-section');
      function pmsg(t) { var m = $('[data-lv-cart-pmsg]', cp); if (m) { m.textContent = t || ''; m.hidden = !t; } }
      function swap(html) {
        var d = document.createElement('div');
        d.innerHTML = html || '';
        var n = d.querySelector('[data-lv-cartpage]');
        if (!n) return;
        cp.innerHTML = n.innerHTML;
        cp.setAttribute('data-count', n.getAttribute('data-count'));
        setCount(n.getAttribute('data-count'));
      }
      function reload() {
        fetch(root + 'cart?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j && j[sid]) swap(j[sid]); })
          .catch(function () {});
      }
      document.addEventListener('lv:cart-updated', reload);
      function chg(key, qty) {
        cp.classList.add('is-loading');
        fetch(cfg.cartChange + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: sid })
        })
          .then(jsonResponse)
          .then(function (res) {
            if (!res.ok) { pmsg(res.j.description || res.j.message || T.updateError); return; }
            if (res.j.sections && res.j.sections[sid]) swap(res.j.sections[sid]); else window.location.reload();
          })
          .catch(function () { pmsg(T.network); })
          .then(function () { cp.classList.remove('is-loading'); });
      }
      cp.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lv-cq]');
        if (!b || !cp.contains(b)) return;
        var line = b.closest('[data-key]');
        if (line) chg(line.getAttribute('data-key'), parseInt(b.getAttribute('data-lv-cq'), 10));
      });
      cp.addEventListener('change', function (e) {
        if (e.target.matches('[data-lv-cqi]')) {
          var line = e.target.closest('[data-key]');
          var q = Math.max(0, parseInt(e.target.value, 10) || 0);
          if (line) chg(line.getAttribute('data-key'), q);
        }
      });
      var nt;
      cp.addEventListener('input', function (e) {
        if (!e.target.matches('[data-lv-note]')) return;
        clearTimeout(nt);
        var v = e.target.value;
        nt = setTimeout(function () {
          fetch(cfg.cartUpdate + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: v }) }).catch(function () {});
        }, 600);
      });
    });
  }

  /* 12. Centro de ayuda */
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function initHelp(scope) {
    $$('[data-lv-help]', scope).forEach(function (h) {
      if (h.dataset.lvReady) return;
      h.dataset.lvReady = '1';
      var q = $('[data-lv-help-q]', h), faqs = $$('[data-lv-faq]', h), none = $('[data-lv-help-none]', h), cat = '';
      var cats = $$('[data-lv-help-cat]', h);
      function apply() {
        var term = norm(q ? q.value.trim() : ''), shown = 0;
        faqs.forEach(function (f) {
          var ok = (!cat || f.getAttribute('data-cat') === cat) && (!term || norm(f.textContent).indexOf(term) !== -1);
          f.hidden = !ok;
          if (ok) shown++;
          if (term && ok) f.open = true;
        });
        if (none) none.hidden = shown > 0;
      }
      if (q) q.addEventListener('input', apply);
      cats.forEach(function (b) {
        b.addEventListener('click', function () {
          cat = b.getAttribute('data-lv-help-cat');
          cats.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          apply();
        });
      });
    });
  }

  /* 13. Varios: pie de página, direcciones, formularios */
  function initMisc(scope) {
    if (window.innerWidth < 990) $$('[data-lv-ft-col]', scope).forEach(function (d) { d.open = false; });
    try {
      var p = new URLSearchParams(window.location.search);
      $$('[data-lv-prefill]', scope).forEach(function (inp) { var v = p.get(inp.getAttribute('data-lv-prefill')); if (v && !inp.value) inp.value = v; });
    } catch (e) {}
    $$('[data-lv-country]', scope).forEach(function (c) {
      var form = c.closest('form'), prov = form && $('[data-lv-province]', form), wrap = form && $('[data-lv-province-wrap]', form);
      if (c.dataset.default) $$('option', c).forEach(function (o) { if (o.value === c.dataset.default) o.selected = true; });
      function fill() {
        if (!prov) return;
        var o = c.options[c.selectedIndex], list = [];
        try { list = JSON.parse(o.getAttribute('data-provinces') || '[]'); } catch (e) {}
        prov.innerHTML = list.map(function (x) { return '<option value="' + esc(x[0]) + '"' + (x[0] === prov.dataset.default ? ' selected' : '') + '>' + esc(x[1]) + '</option>'; }).join('');
        if (wrap) wrap.hidden = !list.length;
      }
      c.addEventListener('change', fill);
      fill();
    });
    $$('[data-lv-confirm]', scope).forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm(f.getAttribute('data-lv-confirm'))) e.preventDefault(); });
    });
  }

  /* 14. Foto ampliada (zoom) en la ficha y "Ver todo" de marcas */
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-lv-zoom]');
    if (z) {
      var d = $('[data-lv-zoomd]'), im = d && $('[data-lv-zoomd-img]', d);
      if (!d || !im || typeof d.showModal !== 'function') return;
      im.src = z.getAttribute('data-lv-zoom');
      im.alt = z.getAttribute('data-lv-zoom-alt') || '';
      d.classList.remove('is-big');
      d.showModal();
      return;
    }
    var zd = e.target.closest('[data-lv-zoomd]');
    if (zd) {
      if (e.target.closest('[data-lv-zoomd-close]') || e.target === zd) { zd.close(); return; }
      if (e.target.matches('[data-lv-zoomd-img]')) zd.classList.toggle('is-big');
      return;
    }
    var more = e.target.closest('[data-lv-brands-more]');
    if (more) {
      var ul = more.closest('ul');
      more.setAttribute('aria-expanded', 'true');
      if (ul) { ul.classList.add('is-all'); var n = $('.lv-br-x a', ul); if (n) n.focus(); }
    }
  });

  function init(scope) {
    initSliders(scope); initCountdowns(scope); initPdp(scope); initReco(scope); initColl(scope);
    initCartPage(scope); initHelp(scope); initRecent(scope); initMisc(scope); initStatus();
  }
  init(document);
  (function () {
    if (reduced || !window.IntersectionObserver || (window.Shopify && Shopify.designMode)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target; io.unobserve(t); t.classList.add('is-in');
        setTimeout(function () { t.classList.remove('lv-rv', 'is-in'); }, 1300);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('#MainContent > .shopify-section').forEach(function (s) {
      if (s.getBoundingClientRect().top > innerHeight) { s.classList.add('lv-rv'); io.observe(s); }
    });
  })();
  setInterval(initStatus, 60000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
